import { useQuery } from '@tanstack/react-query';
import bookingApi from '@/features/public/booking/api/bookingApi.ts';
import { bookingApiQueryKeys } from '@/features/public/booking/api/bookingApi.queryKeys.ts';
import { getTemporalIdForIndex } from '@/features/shared/booking/utils/temporalId.ts';
import timeUtils from '@/utils/timeUtils.ts';

const useGetBookingTourOptions = (
  orgSlug: string,
  tourSlug: string,
  participantBirthDate?: Date,
) => {
  return useQuery({
    queryKey: bookingApiQueryKeys.bookingTourOptions(
      orgSlug,
      tourSlug,
      timeUtils.toJavaDate(participantBirthDate!),
    ),
    queryFn: async () => {
      const options = await bookingApi.getBookingOptionForParticipant(
        orgSlug,
        tourSlug,
        {
          temporalId: getTemporalIdForIndex(0),
          firstName: 'firstName',
          lastName: 'lastName',
          birthDate: timeUtils.toJavaDate(participantBirthDate!),
          customValues: {},
          selectedOptions: {},
        },
      );
      return [...options].sort((a, b) => a.orderIndex - b.orderIndex);
    },
    enabled: !!participantBirthDate,
    staleTime: 0,
  });
};

export default useGetBookingTourOptions;
